var _stop, _stop2, _stop3, _stop4, _stop5, _stop6, _stop7, _stop8, _stop9, _stop10, _stop11, _stop12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgTextToSpeechSelected(props) {
  const _id6 = useUniqueInlineId();
  const _id5 = useUniqueInlineId();
  const _id4 = useUniqueInlineId();
  const _id3 = useUniqueInlineId();
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 18.635c.341 0 .618.277.618.62v3.626a.619.619 0 11-1.238 0v-3.627c0-.342.277-.619.62-.619z",
    fill: `url(#${_id})`,
    stroke: `url(#${_id2})`,
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.577 2.468c-.46.416-.727.96-.879 1.459-.178.586-.182 1.163-.182 1.883v4.437c0 .252-.006.494-.011.727-.014.621-.027 1.186.067 1.75.056.335.15.62.268.86.145.299.33.54.536.739.262.251.564.437.87.574a4.247 4.247 0 001.5.352h.987c.858 0 1.461-.212 1.893-.5.435-.29.733-.681.938-1.091.206-.413.313-.833.366-1.155a4.142 4.142 0 00.052-.48v-5.8c0-.173.003-.34.005-.501.008-.67.016-1.25-.139-1.811-.294-1.069-1.037-1.605-1.756-1.887a4.343 4.343 0 00-1.344-.286h-.016v-.619.619h-.967c-1.062 0-1.74.326-2.188.73zm3.156-1.349V.5h-.968C7.422.5 6.442.923 5.748 1.549c-.682.615-1.042 1.385-1.234 2.017-.237.777-.236 1.524-.236 2.21v4.471c0 .189-.005.39-.01.6-.015.655-.032 1.391.083 2.08.075.448.203.846.375 1.2.213.437.488.796.793 1.09.385.368.813.628 1.223.81a5.477 5.477 0 001.965.46H8.765v-.613.614h.968c1.075 0 1.923-.27 2.58-.709a4.014 4.014 0 001.358-1.568 5.372 5.372 0 00.48-1.505 5.37 5.37 0 00.07-.685V12.001L13.6 12h.62V6.223c0-.132.002-.271.004-.415.01-.68.023-1.477-.183-2.226-.43-1.559-1.543-2.336-2.498-2.71A5.58 5.58 0 009.75.5h-.016l-.001.619z",
    fill: `url(#${_id3})`
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.732 1.738h.016l.076.004a4.343 4.343 0 011.267.282c.72.282 1.463.818 1.757 1.887.155.561.147 1.14.139 1.81-.002.162-.005.329-.005.502V12.023c-.001.02-.002.055-.006.1-.006.088-.02.22-.046.38-.053.322-.16.742-.366 1.155-.205.41-.503.801-.938 1.091-.432.288-1.035.5-1.893.5h-.987l-.088-.004a4.247 4.247 0 01-1.411-.348 3.04 3.04 0 01-.87-.574 2.576 2.576 0 01-.537-.738 3.13 3.13 0 01-.268-.861c-.094-.564-.081-1.129-.067-1.75.005-.233.01-.475.01-.727V5.81c0-.72.005-1.297.183-1.883.152-.5.418-1.043.88-1.459.447-.404 1.125-.73 2.187-.73h.967zm0 0h-.001m.001 0v-.619m0 .619v-.619m0 0V.5h-.967C7.422.5 6.442.923 5.748 1.549c-.682.615-1.042 1.385-1.234 2.017-.237.777-.236 1.524-.236 2.21v4.471c0 .189-.005.39-.01.6-.015.655-.032 1.391.083 2.08.075.448.203.846.375 1.2.213.437.488.796.793 1.09.385.368.813.628 1.223.81a5.477 5.477 0 001.965.46H8.765M9.733 1.12V.5h.016a2.305 2.305 0 01.152.006 5.58 5.58 0 011.643.365c.955.375 2.069 1.152 2.498 2.711.206.749.194 1.546.183 2.226-.002.144-.005.283-.005.415V12h-.619l.62.001v.02l-.002.043a5.37 5.37 0 01-.068.642c-.067.403-.202.95-.48 1.505a4.014 4.014 0 01-1.358 1.568c-.657.438-1.505.709-2.58.709h-.968m0 0v-.614.614z",
    stroke: `url(#${_id4})`,
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.512 9.205c.342 0 .62.277.62.619V12a6.635 6.635 0 006.634 6.635h.968A6.636 6.636 0 0016.369 12V9.824a.619.619 0 111.238 0V12a7.874 7.874 0 01-7.873 7.873h-.968A7.873 7.873 0 01.893 12V9.824c0-.342.278-.62.62-.62z",
    fill: `url(#${_id5})`,
    stroke: `url(#${_id6})`,
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 9.862,
    y1: 23.455,
    x2: 9.862,
    y2: 18.635,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664FF9"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1253FA"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id2,
    x1: 9.862,
    y1: 23.455,
    x2: 9.862,
    y2: 18.635,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664FF9"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1253FA"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id3,
    x1: 14.183,
    y1: 16.338,
    x2: 14.183,
    y2: 0.5,
    gradientUnits: "userSpaceOnUse"
  }, _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664FF9"
  })), _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1253FA"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id4,
    x1: 14.183,
    y1: 16.338,
    x2: 14.183,
    y2: 0.5,
    gradientUnits: "userSpaceOnUse"
  }, _stop7 || (_stop7 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664FF9"
  })), _stop8 || (_stop8 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1253FA"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id5,
    x1: 17.528,
    y1: 19.773,
    x2: 17.528,
    y2: 9.205,
    gradientUnits: "userSpaceOnUse"
  }, _stop9 || (_stop9 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664FF9"
  })), _stop10 || (_stop10 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1253FA"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id6,
    x1: 17.528,
    y1: 19.773,
    x2: 17.528,
    y2: 9.205,
    gradientUnits: "userSpaceOnUse"
  }, _stop11 || (_stop11 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664FF9"
  })), _stop12 || (_stop12 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1253FA"
  })))));
}
export default SvgTextToSpeechSelected;